import React, { useState } from 'react';
import PropTypes from 'prop-types';
import MaskedInput from 'react-text-mask';
import { Input } from '@mui/material';
import styled from 'styled-components';
import { dateMask } from '../../utils/resources/MaskFunctions';

const StyledInput = styled(Input)`
  min-width: 100%;

  &:before {
    border-bottom: none;
  }
  &:after {
    border-bottom: none;
  }
  &:hover:not(.Mui-disabled):before {
    border-bottom: none;
  }
`;

const MaskedDate = React.forwardRef(function MaskedDate(props, ref) {
  return (
    <MaskedInput
      id={props.id}
      name={props.name}
      value={props.value}
      inputMode="text"
      type="text"
      required={props.required}
      onChange={props.onChange}
      mask={dateMask}
      placeholder="MM/DD/YYYY"
      keepCharPositions
    />
  );
});

export const MaskedDateInput = React.forwardRef(function MaskedDateInput(
  props,
  ref
) {
  const handleChange = (e) => {
    const date = Date.parse(e.target.value);

    props.onChange(e);

    if (props.maxDate && date > Date.parse(props.maxDate)) {
      props.setError(true);
      props.setErrorMessage('Date cannot be in the future.');
      return;
    }

    if (props.minDate && date < Date.parse(props.minDate)) {
      props.setError(true);
      props.setErrorMessage('Date cannot be in the past.');
      return;
    }

    props.setError(false);
    props.setErrorMessage('');
  };

  return (
    <StyledInput
      value={props.value}
      onChange={handleChange}
      onClick={props.onClick}
      onBlur={props.onBlur}
      name={props.name}
      ref={ref}
      id="formatted-text-mask-input"
      inputComponent={MaskedDate}
      placeholder="MM/DD/YYYY"
    />
  );
});

MaskedDateInput.propTypes = {
  name: PropTypes.string.isRequired,
  onChange: PropTypes.func.isRequired,
};
